import { setupGraphqlClient } from "./services/setupGraphqlClient";

// this is done in a separate file so that Root component can be hot-reloaded without losing graphql cache
export const { client, addEventListener } = setupGraphqlClient();
